import { AliasToken, PresetColorType } from "antd/es/theme/interface";
import styled from "styled-components";

// The entire typing here is a a big hack to allow using any valid color
type ColorPaletteKeyIndex = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
type ColorTokenKey = (keyof AliasToken & `color${string}`) | `${keyof PresetColorType}${ColorPaletteKeyIndex}`;

export default styled.div<{ $colorTokenKey?: ColorTokenKey }>`
  width: ${p => p.theme.controlHeight}px;
  height: ${p => p.theme.controlHeight}px;
  
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${p => p.$colorTokenKey && p.theme[p.$colorTokenKey]};
`;
